import { createSelector } from '@reduxjs/toolkit';

export const selectFeatureFilter = createSelector(
  (state) => state.evaluationfilter.data?.feature_filter,
  (featureFilter) => {
    return featureFilter;
  }
);

export const selectorForSelectedFilter = createSelector(
  (state) => state.evaluationfilter,
  (filter) => {
    return {
      LOB: filter.LOB,
      LOBTeam: filter.LOBTeam,
      LOBTeamAgent: filter.LOBTeamAgent
    };
  }
);
